import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { zPrice, zText } from '../primitives';

export const deliverySuburbSchema = z.object({
  fee: z.number(),
  suburbName: z.string(),
  suburbPostcode: z.string(),
  uuid: z.string().default(() => uuidv4()),

  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
});
export type DeliverySuburb = z.output<typeof deliverySuburbSchema>;

export const deliverySuburbStrictSchema = deliverySuburbSchema.safeExtend({
  fee: zPrice,
  suburbName: zText.pipe(z.string().min(1).max(40)),
  suburbPostcode: zText.pipe(z.string().min(4).max(4)),
  uuid: z.guid(),
});

export const deliverySuburbCvxSchema = deliverySuburbSchema.safeExtend({
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type DeliverySuburbCvx = z.output<typeof deliverySuburbCvxSchema>;
